@use '../../../../app/styles/common/colors';
@use '../../../../app/styles/common/mixins';

.container {
  display: flex;
  flex-direction: column;
  gap: var(--spasing12) 0;

  @include mixins.laptop {
    gap: var(--spasing16) 0;
  }
}

.inputContainer {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.input {
  flex: 1;
  background: var(--bg-tonal-neutral);
  border: 1px solid colors.$borderPrimary;
  border-radius: 12px;
}

.tags {
  gap: var(--spasing06);
}
